export default "__VITE_ASSET__Bc5IqDre__"